/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";
import {
  SpendRuleTargetCondition,
  SpendRuleTargetCondition$Outbound,
  SpendRuleTargetCondition$outboundSchema,
} from "./spendruletargetcondition.js";

/**
 * Rule action: flag or block. Omit to preserve the current action.
 */
export const UpdateSpendRuleRequestBodyAction = {
  Flag: "flag",
  Block: "block",
} as const;
/**
 * Rule action: flag or block. Omit to preserve the current action.
 */
export type UpdateSpendRuleRequestBodyAction = ClosedEnum<
  typeof UpdateSpendRuleRequestBodyAction
>;

/**
 * UTC calendar window the budget covers. Omit to preserve the current window.
 */
export const UpdateSpendRuleRequestBodyWindowKind = {
  Daily: "daily",
  Weekly: "weekly",
  Monthly: "monthly",
} as const;
/**
 * UTC calendar window the budget covers. Omit to preserve the current window.
 */
export type UpdateSpendRuleRequestBodyWindowKind = ClosedEnum<
  typeof UpdateSpendRuleRequestBodyWindowKind
>;

export type UpdateSpendRuleRequestBody = {
  /**
   * Rule action: flag or block. Omit to preserve the current action.
   */
  action?: UpdateSpendRuleRequestBodyAction | undefined;
  /**
   * Description of what the rule covers. Omit to preserve the current description.
   */
  description?: string | undefined;
  /**
   * Whether the rule is active. Omit to preserve the current state.
   */
  enabled?: boolean | undefined;
  /**
   * The rule ID.
   */
  id: string;
  /**
   * Per-person budget in USD for one window. Omit to preserve the current limit.
   */
  limitUsd?: number | undefined;
  /**
   * The rule name. Omit to preserve the current name.
   */
  name?: string | undefined;
  target?: SpendRuleTargetCondition | undefined;
  /**
   * Percentage of the limit at which a warning event is emitted. Omit to preserve the current threshold.
   */
  warnAtPct?: number | undefined;
  /**
   * UTC calendar window the budget covers. Omit to preserve the current window.
   */
  windowKind?: UpdateSpendRuleRequestBodyWindowKind | undefined;
};

/** @internal */
export const UpdateSpendRuleRequestBodyAction$outboundSchema: z.ZodMiniEnum<
  typeof UpdateSpendRuleRequestBodyAction
> = z.enum(UpdateSpendRuleRequestBodyAction);

/** @internal */
export const UpdateSpendRuleRequestBodyWindowKind$outboundSchema: z.ZodMiniEnum<
  typeof UpdateSpendRuleRequestBodyWindowKind
> = z.enum(UpdateSpendRuleRequestBodyWindowKind);

/** @internal */
export type UpdateSpendRuleRequestBody$Outbound = {
  action?: string | undefined;
  description?: string | undefined;
  enabled?: boolean | undefined;
  id: string;
  limit_usd?: number | undefined;
  name?: string | undefined;
  target?: SpendRuleTargetCondition$Outbound | undefined;
  warn_at_pct?: number | undefined;
  window_kind?: string | undefined;
};

/** @internal */
export const UpdateSpendRuleRequestBody$outboundSchema: z.ZodMiniType<
  UpdateSpendRuleRequestBody$Outbound,
  UpdateSpendRuleRequestBody
> = z.pipe(
  z.object({
    action: z.optional(UpdateSpendRuleRequestBodyAction$outboundSchema),
    description: z.optional(z.string()),
    enabled: z.optional(z.boolean()),
    id: z.string(),
    limitUsd: z.optional(z.number()),
    name: z.optional(z.string()),
    target: z.optional(SpendRuleTargetCondition$outboundSchema),
    warnAtPct: z.optional(z.int()),
    windowKind: z.optional(UpdateSpendRuleRequestBodyWindowKind$outboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      limitUsd: "limit_usd",
      warnAtPct: "warn_at_pct",
      windowKind: "window_kind",
    });
  }),
);

export function updateSpendRuleRequestBodyToJSON(
  updateSpendRuleRequestBody: UpdateSpendRuleRequestBody,
): string {
  return JSON.stringify(
    UpdateSpendRuleRequestBody$outboundSchema.parse(updateSpendRuleRequestBody),
  );
}
